import React from "react";
import { useNavigate } from "react-router-dom";
import { Database, Archive, Boxes, ArrowRight, Clock } from "lucide-react";
import Layout from "../components/Layout";

const APPS = [
  {
    key: "erp",
    title: "ERP Amel",
    icon: Database,
    description:
      "Rapoarte read-only din app.amel-online.ro. Tabel Oferte cu filtre si export Excel.",
    modules: ["CRM", "Clienti", "Comenzi"],
    to: "/descarcari",
    ready: true,
  },
  {
    key: "erp-vechi",
    title: "ERP VECHI",
    icon: Archive,
    description:
      "Rapoarte read-only din arhiva.amel-online.ro. Tabel Oferte cu filtre si export Excel.",
    modules: ["CRM", "Clienti", "Comenzi"],
    to: "/erp-vechi",
    ready: true,
  },
  {
    key: "configurator",
    title: "Configuratorul",
    icon: Boxes,
    description:
      "Rapoarte read-only din oferte.amel-online.ro. Oferte Configurator cu filtre si export Excel.",
    modules: ["ScanX", "Configurator", "Obloane"],
    to: "/configurator",
    ready: true,
  },
];

export default function Aplicatii() {
  const navigate = useNavigate();

  return (
    <Layout title="Aplicatii">
      <section className="mb-8">
        <p className="text-xs uppercase tracking-widest text-slate-400">Platforma</p>
        <h2 data-testid="aplicatii-title" className="text-2xl font-semibold">
          Aplicatii
        </h2>
        <p className="mt-1 max-w-2xl text-sm text-slate-500">
          Alege aplicatia. ERP Amel si ERP VECHI grupeaza modulele CRM, Clienti si Comenzi.
          Configuratorul grupeaza ScanX, Configurator si Obloane.
        </p>
      </section>

      <div className="grid grid-cols-1 gap-6 md:grid-cols-2 xl:grid-cols-3">
        {APPS.map(({ key, title, icon: Icon, description, modules, to, ready }) => (
          <article
            key={key}
            data-testid={`app-card-${key}`}
            onClick={() => navigate(to)}
            className="group cursor-pointer rounded-xl border border-slate-200 bg-white p-6 transition hover:border-accent-500/60 hover:bg-slate-100"
          >
            <div className="flex items-start justify-between gap-4">
              <div className="grid h-12 w-12 place-items-center rounded-lg bg-accent-500/10 text-accent-500">
                <Icon size={24} />
              </div>
              {ready ? (
                <span className="rounded bg-emerald-500/15 px-2 py-0.5 text-[11px] uppercase tracking-widest text-emerald-700">
                  Activ
                </span>
              ) : (
                <span className="inline-flex items-center gap-1 rounded bg-slate-100 px-2 py-0.5 text-[11px] uppercase tracking-widest text-slate-500">
                  <Clock size={11} /> In dezvoltare
                </span>
              )}
            </div>

            <h3 className="mt-5 text-xl font-semibold">{title}</h3>
            <p className="mt-2 text-sm text-slate-500">{description}</p>

            <div className="mt-4 flex flex-wrap gap-2">
              {modules.map((m) => (
                <span
                  key={m}
                  className="rounded border border-slate-200 bg-slate-100 px-2.5 py-1 text-xs text-slate-600"
                >
                  {m}
                </span>
              ))}
            </div>

            <div className="mt-6 inline-flex items-center gap-1.5 text-sm font-medium text-accent-500">
              Deschide
              <ArrowRight size={15} className="transition group-hover:translate-x-1" />
            </div>
          </article>
        ))}
      </div>
    </Layout>
  );
}
